import { Card, CardContent, Divider, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import Content from './Content';
import { singleCountryDashboardSelector } from '../../../state';

const CountryConciliation = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const title = t('dashboard.conciliations-state.title');
  const singleCountryDashboard = useSelector(singleCountryDashboardSelector);

  return !singleCountryDashboard ? (
    <Card
      data-guide="country-conciliation-card"
      sx={{
        borderRadius: 3,
        boxShadow: 2,
        background: theme.palette.background.paper,
      }}
    >
      <CardContent>
        <Typography variant="subtitle2">{title}</Typography>
        <Divider />
        <Content />
      </CardContent>
    </Card>
  ) : null;
};

export default CountryConciliation;
